module.exports = __webpack_public_path__ + "media/choose_coverage_level_bg_desktop.34fd06dd.svg";